import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Menu extends Component {
	render() {
		return (
		<div className="Menu">
			<a href="/planaire/personnages"><div className="MenuItem"><FontAwesomeIcon icon="users"/><br/>Personnages</div></a>			
			<a href="/planaire/objets"><div className="MenuItem"><FontAwesomeIcon icon="box-open"/><br/>Objets Partagés</div></a>
			
		</div>
		);
	}
}
// <!-- <a href="/planaire/contrats"><div className="MenuItem"><FontAwesomeIcon icon="file"/><br/>Contrats</div></a> -->
export default Menu;
